import {
  PaidFlowTypesEnum,
  PaymentMethodTypesEnum,
} from "@propertelligent/client-api";
import type { TransactionRow } from "./transactionTypes";

// A negative-amount row that is not a Refund is a system-posted Plaid reversal (returned or
// failed-after-settle). Without this gate it would offer Refund/Edit because it inherits the
// original's Plaid method + receivable flow. Editing it would need a positive amount and turn the
// reversal into income; deleting it would re-inflate income. Refund rows (also negative) keep
// their menu. Tables render no action menu for reversal rows.
export const isReversalTransaction = (
  transaction?: Pick<TransactionRow, "amount" | "paymentMethodTypeId"> | null,
) =>
  Number(transaction?.amount) < 0 &&
  transaction?.paymentMethodTypeId !== PaymentMethodTypesEnum.Refund;

export const canDeleteTransaction = (
  transaction?: Pick<TransactionRow, "paymentMethodTypeId" | "amount"> | null,
) =>
  transaction?.paymentMethodTypeId !== PaymentMethodTypesEnum.Plaid &&
  !isReversalTransaction(transaction);

export const canRefundTransaction = (
  transaction?: Pick<
    TransactionRow,
    "paymentMethodTypeId" | "paymentDueAccountPaidFlowTypeId"
  > | null,
) =>
  transaction?.paymentMethodTypeId === PaymentMethodTypesEnum.Plaid &&
  transaction?.paymentDueAccountPaidFlowTypeId ===
    PaidFlowTypesEnum.Receiveable;
